export enum AssistantBackgroundNoiseTypeModel {
  OFFICE = "office",
  CAFE = "cafe",
}

export type AssistantBackgroundNoiseRecordModel = {
  isEnabled: boolean;
  type: AssistantBackgroundNoiseTypeModel | null;
  volume: number;
};

export type AssistantBackgroundNoiseCompactModel =
  AssistantBackgroundNoiseRecordModel;
